export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fa1d871556d90cee1858ac81a3c16b5405379f39b&name=fetchTypeahead!'